import * as React from 'react'
import styled from 'styled-components'
import { theme } from 'utils/styledHelper'

import injectE2E from '../injectE2E'

type PropsType = {
  children: React.ReactNode
  className?: string
  e2e?: string
  onClick?: () => void
  selected?: boolean
}

const Wrapper = styled.div.attrs(injectE2E)`
  position: relative;
  flex: 1 auto;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 1rem;
  box-sizing: border-box;
  cursor: pointer;
  @media (max-width: ${(p) => p.theme.screenSizes.sm}) {
    order: 1;
    &.hidden {
      order: 2;
    }
  }
  @media (min-width: ${(p) => p.theme.screenSizes.sm}) {
    display: flex;
    justify-content: center;
    order: 1;
    &:hover {
      & :last-child {
        opacity: 1;
      }
    }
  }
`
const Bar = styled.div<{ selected: boolean }>`
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  height: 0.2rem;
  transition-duration: 0.3s;
  transition-timing-function: ease-in-out;
  background-color: ${theme('tabMenuBarColor')};
  opacity: ${(props) => (props.selected === true ? '1' : '0')};
`

const TabMenuItem = ({
  children,
  className,
  e2e = 'defaultTabMenuItem',
  selected = false,
  ...rest
}: PropsType) => (
  <Wrapper
    className={selected === true ? className : `${className ?? ''} disabled`}
    e2e={e2e}
    {...rest}
  >
    <>
      {children}
      <Bar selected={selected} />
    </>
  </Wrapper>
)

export default TabMenuItem
